import type { TFunction } from 'i18next';
import * as yup from 'yup';

import { OrganizationUpdateRequestDTOEmployeeCount } from '@/api/generated';

export const getCreateFolderBasicTabSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup.string().required(
      t('validation:mandatory', {
        field: t('organizations:layouts.organizations.create.fields.organizationName')
      })
    ),
    legacyId: yup.string().nullable()
  });

export const getCreateSubFolderBasicTabSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup.string().required(
      t('validation:mandatory', {
        field: t('organizations:layouts.organizations.create.fields.organizationName')
      })
    ),
    legacyId: yup.string().nullable()
  });

export const getCreateSubOrgBasicTabSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup.string().required(
      t('validation:mandatory', {
        field: t('organizations:layouts.organizations.create.fields.organizationName')
      })
    ),
    legalName: yup.string().required(
      t('validation:mandatory', {
        field: t('organizations:layouts.organizations.create.fields.subOrganizationLegalName')
      })
    ),
    offices: yup.string().required(
      t('validation:mandatory', {
        field: t('organizations:layouts.organizations.create.fields.office')
      })
    ),
    countries: yup.string().required(
      t('validation:mandatory', {
        field: t('organizations:layouts.organizations.create.fields.country')
      })
    )
  });

export const getCreateSubOrgMoreInfoTabSchema = (t: TFunction) =>
  yup.object().shape({
    keyAccountManagers: yup.array().min(
      1,
      t('validation:atLeastOne', {
        field: t('organizations:layouts.organizations.create.fields.keyAccountManagers')
      })
    ),
    employeeCount: yup
      .string()
      .oneOf(
        Object.keys(OrganizationUpdateRequestDTOEmployeeCount),
        t('validation:validSelection', { field: t('orgSettings.fields.numberOfEmployees') })
      )
      .required(t('validation:mandatory', { field: t('orgSettings.fields.numberOfEmployees') })),

    jiraId: yup.string().nullable(),
    legacyId: yup.string().nullable(),
    pipedriveId: yup.string().nullable()
  });
